import React from "react";
import JamezzFormV2 from "../JamezzForm/JamezzFormV2";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import Algemeen from "./Tabs/Algemeen";
import AuthProvider from "../../auth/AuthProvider";

const endPoint = "core/defaultsettings";

function DefaultsettingsForm(props) {
  return (
    <AuthProvider prefix={"settings"}>
      <JamezzFormV2
        endPoint={endPoint}
        pageTitle={getTranslation("defaultsettings.form.pageTitle", "Settings collection")}
        tabs={[
          {
            right: "algemeen",
            tabButton: <TranslationWrapper tDefault={"Algemeen"} tKey={"tags.form.tabs.algemeen"} />,
            tabContent: <Algemeen />,
          },
        ]}
      />
    </AuthProvider>
  );
}

export default DefaultsettingsForm;
